import { render, staticRenderFns } from "./MemberGrade.vue?vue&type=template&id=1d874d1d&"
import script from "./MemberGrade.vue?vue&type=script&lang=ts&"
export * from "./MemberGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports